import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "same-color-balls" }
const _hoisted_2 = { class: "axis-section" }
const _hoisted_3 = { class: "axis-label" }
const _hoisted_4 = { class: "color-row" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "axis-section" }
const _hoisted_7 = { class: "axis-label" }
const _hoisted_8 = { class: "count-row" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "count-value" }
const _hoisted_11 = { class: "count-odds" }

import { computed, ref } from 'vue'
import type { Market, MarketOutcome } from '@/stores/game'
import {
  BALL_COLOR_ORDER,
  BALL_COLOR_STYLES,
  matchesSameColorOutcome,
  normalizeSpecifier,
  type BallColorSlug,
} from '@/constants/sameColorBalls'
import { formatOdds } from '@/utils/currency'


const __default__ = {
  name: 'SameColorBallsSelector',
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    market: {}
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const selectedColor = ref<BallColorSlug | null>(null)
const selectedCount = ref<string | null>(null)

const colorSlugs = BALL_COLOR_ORDER

const counts = computed(() => {
  const values = props.market.outcomes
    .map((outcome) => normalizeSpecifier(outcome.specifier))
    .filter((value) => value !== '')
  return [...new Set(values)].sort((a, b) => Number(a) - Number(b))
})

const countOdds = computed(() => {
  const map: Record<string, string> = {}
  for (const outcome of props.market.outcomes) {
    const specifier = normalizeSpecifier(outcome.specifier)
    if (specifier) {
      map[specifier] = outcome.odds
    }
  }
  return map
})

const resolvedOutcome = computed(() => {
  if (!selectedColor.value || !selectedCount.value) {
    return null
  }

  return props.market.outcomes.find((outcome) =>
    matchesSameColorOutcome(outcome, selectedColor.value!, selectedCount.value!)
  ) ?? null
})

function getColorButtonStyle(color: BallColorSlug, isSelected: boolean) {
  const style = BALL_COLOR_STYLES[color]
  if (isSelected) {
    return {
      backgroundColor: style.background,
      borderColor: style.border,
      color: style.text,
    }
  }

  return {
    backgroundColor: 'var(--colour-surface-cont-lowest)',
    borderColor: style.border,
    color: 'var(--colour-base-text-colour)',
  }
}

function selectColor(color: BallColorSlug) {
  selectedColor.value = color
  tryAddBet()
}

function selectCount(count: string) {
  selectedCount.value = normalizeSpecifier(count)
  tryAddBet()
}

function tryAddBet() {
  if (resolvedOutcome.value) {
    emit('select', resolvedOutcome.value)
    selectedColor.value = null
    selectedCount.value = null
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('betting.ballColor')), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(colorSlugs), (color) => {
          return (_openBlock(), _createElementBlock("button", {
            key: color,
            type: "button",
            class: _normalizeClass(["color-btn", { selected: selectedColor.value === color }]),
            style: _normalizeStyle(getColorButtonStyle(color, selectedColor.value === color)),
            onClick: ($event: any) => (selectColor(color))
          }, _toDisplayString(_unref(BALL_COLOR_STYLES)[color].label), 15, _hoisted_5))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('betting.atLeast')), 1),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(counts.value, (count) => {
          return (_openBlock(), _createElementBlock("button", {
            key: count,
            type: "button",
            class: _normalizeClass(["count-btn", { selected: selectedCount.value === count }]),
            onClick: ($event: any) => (selectCount(count))
          }, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(count), 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(formatOdds)(countOdds.value[count])), 1)
          ], 10, _hoisted_9))
        }), 128))
      ])
    ])
  ]))
}
}

})